<div class="mb-4">
  <div class="fw-bold">Chapô</div>
  <p [ngClass]="{ 'text-muted': !appraisal.basicInfo.lead }">
    {{ appraisal.basicInfo.lead || "-" }}
  </p>
</div>

<div class="mb-4">
  <div class="fw-bold">Commentaire</div>
  <p [ngClass]="{ 'text-muted': !appraisal.basicInfo.comment }">
    {{ appraisal.basicInfo.comment || "-" }}
  </p>
</div>

<div class="mb-4">
  <p-separator></p-separator>
</div>

<app-valeur-estimee-sans-plus-ou-moins-values
  *ngIf="reportType !== 'references'"
  [appraisal]="appraisal"
  class="mb-4"
></app-valeur-estimee-sans-plus-ou-moins-values>

<app-plus-ou-moins-values
  *ngIf="!!appraisal.addedReducedValues.length"
  [appraisal]="appraisal"
  class="mb-4"
></app-plus-ou-moins-values>

<app-valeur-estimee-avec-plus-ou-moins-values
  *ngIf="!!appraisal.addedReducedValues.length"
  [appraisal]="appraisal"
  class="mb-4"
></app-valeur-estimee-avec-plus-ou-moins-values>

<app-valeur-retenue [appraisal]="appraisal" class="mb-4"></app-valeur-retenue>

<div class="mb-4">
  <p-separator></p-separator>
</div>

<div class="mb-4">
  <div class="fw-bold">Conclusion</div>
  <p [ngClass]="{ 'text-muted': !appraisal.basicInfo.conclusion }">
    {{ appraisal.basicInfo.conclusion || "-" }}
  </p>
</div>
